import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AppIcon } from '../app-icon/app-icon';

@Component({
  selector: 'app-icon-name-desc',
  imports: [AppIcon],
  templateUrl: './app-icon-name-desc.html',
  styleUrl: './app-icon-name-desc.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppIconNameDesc {
  readonly icon = input.required<string>();
  readonly iconText = input<string | undefined>(undefined);
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly color = input('var(--safegpt-secondary)');
  readonly iconColor = input<string | undefined>(undefined);
  readonly iconWidth = input(18);
  readonly iconHeight = input(18);
  readonly fontSize = input<'xs' | 'sm' | 'md'>('sm');
}

